// GuardedRoute.jsx
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../Contexts/authContext";

const GuardedRoute = ({ children, access }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  if (location.pathname === "/") {
    return isAuthenticated ? (
      <Navigate to="/dashboard" replace />
    ) : (
      <Navigate to="/login" replace />
    );
  }

  if (access === "private" && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  /* Commented out to allow access to public routes even when authenticated */
 /*  if (access === "public" && isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  } */

  // publicFree = no guard
  return children;
};

export default GuardedRoute;
